import { buscarAlertas, AlertaEvento } from "../api/m5";
import { postJson } from "../api/client";

export async function montarAlertas(container: HTMLElement): Promise<void> {
  container.innerHTML = `
    <div class="card">
      <table>
        <thead>
          <tr><th>Criado em</th><th>Device</th><th>Tag</th><th>Valor</th><th>Limite</th><th>Status</th><th></th></tr>
        </thead>
        <tbody id="alertas-corpo"></tbody>
      </table>
    </div>
  `;

  async function carregar() {
    const alertas = await buscarAlertas(100);
    const tbody = container.querySelector("#alertas-corpo")!;
    tbody.innerHTML = alertas
      .map((a: AlertaEvento) => {
        const reconhecido = (a as unknown as { reconhecido_em?: string }).reconhecido_em;
        const status = reconhecido
          ? '<span class="badge reconhecido">reconhecido</span>'
          : `<button class="botao secundario" data-id="${a.id}">Reconhecer</button>`;
        return `<tr>
          <td>${a.criado_em}</td><td>${a.device_id}</td><td>${a.tag}</td><td>${a.valor}</td>
          <td><span class="badge ${a.limite_violado}">${a.limite_violado}</span></td>
          <td></td><td>${status}</td>
        </tr>`;
      })
      .join("");

    tbody.querySelectorAll<HTMLButtonElement>("button[data-id]").forEach((botao) => {
      botao.addEventListener("click", async () => {
        // M5 ainda nao expoe escrita para alertas (so leitura) - reconhecer
        // chama o M6 direto. Excecao documentada no README do M7.
        await postJson(`/m6/api/alert-events/${botao.dataset.id}/reconhecer`);
        carregar();
      });
    });
  }

  await carregar();
}
